// SocialFeed — the club's progress narrated as a social network
// (FC 25 pattern): fictional media, fans and rivals react to events.

import { motion } from 'framer-motion'
import { useSocialFeed } from '@/hooks/useSocialFeed'
import { PlayerAvatar } from '../PlayerAvatar'
import { cardItem, staggerContainer, useMotionVariants } from '../../motion/motionTokens'
import { Newspaper, BadgeCheck } from 'lucide-react'
import type { FeedPostData } from '@/config/feedConfig'

function FeedPost({ post }: { post: FeedPostData }) {
  return (
    <motion.div variants={cardItem} className="feed-post">
      <span className="feed-avatar">
        <PlayerAvatar id={post.author.id} name={post.author.name} size={32} />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
          <span className="feed-author">{post.author.name}</span>
          {post.author.kind === 'media' && (
            <BadgeCheck size={12} style={{ color: 'var(--gold)' }} />
          )}
          <span className="feed-handle">{post.author.handle}</span>
        </div>
        <div className="feed-body">{post.body}</div>
      </div>
    </motion.div>
  )
}

export function SocialFeed() {
  const posts = useSocialFeed()
  const container = useMotionVariants(staggerContainer)

  return (
    <div>
      <div className="section-label" style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
        <Newspaper size={13} />
        El runrun del padel
      </div>

      {posts.length === 0 ? (
        <div className="empty-state small">Sin novedades todavia.</div>
      ) : (
        <motion.div className="space-y-2" variants={container} initial="initial" animate="enter">
          {posts.map(post => <FeedPost key={post.id} post={post} />)}
        </motion.div>
      )}
    </div>
  )
}
